// editor strings (ar). Machine-drafted — review with a native speaker before launch.
const editor = {
	editor: {
		// Header / top toolbar
		backToDashboard: 'العودة إلى لوحة التحكم',
		cardTitlePlaceholder: 'عنوان البطاقة',
		previewCard: 'معاينة البطاقة',
		invite: 'دعوة',
		sendCard: 'إرسال البطاقة',
		saveChanges: 'حفظ التغييرات',

		// Left sidebar tool labels
		badgeNew: 'جديد',
		changeCover: 'تغيير الغلاف',
		coverType: 'الغلاف',
		coverStatic: 'صورة ثابتة',
		coverDynamic: 'ديناميكي',
		coverStaticConfirm: 'التحويل إلى غلاف ثابت؟ ستتم إزالة النصوص والشعارات ووسوم الدمج من الغلاف.',
		coverRemoveImage: 'إزالة صورة الغلاف',
		addMessage: 'إضافة رسالة',
		addImage: 'إضافة صورة',
		aiImage: 'صورة بالذكاء الاصطناعي',
		background: 'الخلفية',
		addGif: 'إضافة GIF',
		addVideo: 'إضافة فيديو',
		music: 'الموسيقى',
		callToAction: 'دعوة إلى إجراء',

		// Autosave notification
		autosaveSaving: 'جارٍ الحفظ ...',
		autosaveSaved: 'تم الحفظ تلقائيًا',
		autosaveError: 'خطأ في الحفظ التلقائي!',
		close: 'إغلاق',

		// Font tool
		chooseColor: 'اختر لونًا',
		selectFont: 'اختر الخط',
		showMore: 'عرض المزيد',
		showLess: 'عرض أقل',

		// Text effect tool
		effects: 'التأثيرات',
		fontStyles: 'أنماط الخط',
		effectNone: 'بدون',
		effectHollow: 'مجوف',
		effectLift: 'بارز',
		effectShadow: 'ظل',
		effectNeon: 'نيون',
		effectGlitch: 'خلل',
		effectSplice: 'تقسيم',
		backToFontTool: 'العودة إلى أداة الخط',

		// Image tool
		searchPhotos: 'البحث عن صور',
		search: 'بحث',
		designOnCanva: 'التصميم على Canva',
		uploadImage: 'رفع صورة',
		uploading: 'جارٍ الرفع...',

		// GIF tool
		searchUpload: 'بحث / رفع',
		embedLink: 'تضمين رابط',
		searchGifs: 'البحث عن صور GIF',
		uploadGif: 'رفع GIF',
		trending: 'الرائج',
		pasteGifUrl: 'الصق رابط GIF هنا...',
		loading: 'جارٍ التحميل...',
		addGifButton: 'إضافة GIF',
		gifUrlHint: 'الصق رابطًا مباشرًا لملف GIF (ينتهي بـ .gif) أو رابط صورة مدعوم.',

		// Video tool
		videoTabAdd: 'إضافة فيديو',
		videoTabRecord: 'تسجيل',
		videoTabMyVideos: 'مقاطعي',
		videoAddHint: 'الصق رابط YouTube أو Vimeo أو رابط فيديو مباشر، أو ارفع ملف فيديو.',
		videoUrlPlaceholder: 'https://...',
		add: 'إضافة',
		uploadVideo: 'رفع فيديو',
		videoSupportedHint: 'المدعوم: YouTube، Vimeo، ملفات MP4/WebM.',
		noVideosUploaded: 'لم يتم رفع أي مقاطع فيديو بعد.',
		confirmDeleteVideo: 'هل أنت متأكد أنك تريد حذف هذا الفيديو؟',
		videoPreview: 'معاينة الفيديو',
		deleteSelectedVideo: 'حذف الفيديو المحدد',

		// Music tool
		musicUploaded: 'تم الرفع',
		musicLibrary: 'المكتبة',
		musicUpload: 'رفع',
		searchTracks: 'البحث عن مقاطع...',
		loadingTracks: 'جارٍ تحميل المقاطع...',
		noTracksFound: 'لم يتم العثور على مقاطع',
		dropAudioHere: 'أفلت ملف الصوت هنا',
		audioFormats: 'MP3 أو WAV أو OGG',
		moodHappy: 'سعيد',
		moodSad: 'حزين',
		moodRelaxing: 'مريح',
		moodEnergetic: 'حيوي',
		moodRomantic: 'رومانسي',
		moodEpic: 'ملحمي',
		moodChill: 'هادئ',
		moodUplifting: 'محفّز',

		// Call to action panel
		createCta: 'إنشاء دعوة إلى إجراء',
		buttonLink: 'رابط الزر (URL)',
		buttonText: 'نص الزر',
		buttonColor: 'لون الزر',
		textColor: 'لون النص',
		borderStyle: 'نمط الحد',

		// Video card sidebar panel
		videoCard: 'بطاقة فيديو',
		videoCardIntro:
			'صمّم غلاف بطاقتك، ثم شارك رابط الدعوة حتى يتمكن المساهمون من تسجيل رسائلهم المصورة أو رفعها.',
		shareInviteLink: 'مشاركة رابط الدعوة',
		shareInviteLinkHint: 'انسخ هذا الرابط وأرسله إلى أي شخص تريده أن يساهم بفيديو في هذه البطاقة.',
		linkCopied: 'تم نسخ الرابط!',
		copyInviteLink: 'نسخ رابط الدعوة',
		howItWorks: 'كيف يعمل',
		videoCardStep1: 'صمّم غلاف بطاقتك وصفحاتها باستخدام المحرر',
		videoCardStep2: 'احفظ وانسخ رابط الدعوة لمشاركته مع المساهمين',
		videoCardStep3: 'يقوم المساهمون بتسجيل مقاطع الفيديو أو رفعها عبر الرابط',
		videoCardStep4: 'انتقل إلى لوحة بطاقات الفيديو لضبط الإعدادات ومراجعة الإرسالات والعرض والإرسال',
		videoCardManageHint: 'أدر الإرسالات وحدد المواعيد النهائية وأعد ترتيب مقاطع الفيديو واعرض الفيديو النهائي من',
		videoCardsDashboard: 'بطاقات الفيديو',

		// Merge tags panel
		createWorkflowTitle: 'إنشاء سير عمل مع التكاملات',
		beta: 'تجريبي',
		createWorkflowDesc:
			'اربط تطبيقاتك في دقائق. أنشئ أي سير عمل تتخيله باستخدام Zapier أو Pabbly Connect. أتمت عملياتك وادمجها مع تطبيقاتك المفضلة لمزيد من التركيز وأقل إحباط.',
		createZapierWorkflow: 'إنشاء سير عمل Zapier',
		createPabblyWorkflow: 'إنشاء سير عمل Pabbly Connect',
		or: 'أو',
		sendViaEmailPlatform: 'الإرسال عبر منصة البريد الإلكتروني الخاصة بك',
		personalisedLinkDesc:
			'احصل على رابط مخصص مع علامات الدمج المنسقة لمنصة البريد الإلكتروني الخاصة بك (SendGrid، Brevo، HubSpot، Mailchimp).',
		getPersonalisedLink: 'الحصول على رابط مخصص',
		getEmbedCode: 'الحصول على كود تضمين البريد الإلكتروني',
		customizeAndSendBulk: 'التخصيص والإرسال بالجملة',
		customizeAndSendBulkDesc:
			'باستخدام %{app} يمكنك تخصيص بطاقاتك. أنشئ بطاقة واحدة وأرسلها إلى جميع جهات اتصالك باستخدام علامات الدمج.',
		uploadCsv: 'رفع CSV',
		selectFromLists: 'الاختيار من القوائم',
		clearAll: 'مسح الكل',
		noCsvUploaded: 'لم ترفع ملف csv بعد. ابدأ برفع ملف من جهازك.',
		deleteCsv: 'حذف CSV',

		// Upload CSV modal
		uploadCsvTitle: 'ارفع ملف CSV الخاص بك هنا',
		uploadCsvDesc:
			'بمجرد رفع ملف CSV، سيقوم %{app} بربط بياناتك بعلامات الدمج المتاحة إلى جانب العلامات المخصصة لتتمكن من تخصيص كل بطاقة وإرسال البطاقات إلى أي عدد تريده من جهات الاتصال',
		cancel: 'إلغاء',
		next: 'التالي',

		// Invite collaborators panel
		backToMain: 'العودة إلى الرئيسية',
		inviteCollaborators: 'دعوة المتعاونين',
		tabDirectLink: 'رابط مباشر',
		tabEmail: 'البريد الإلكتروني',
		tabSocial: 'وسائل التواصل',

		// Text fallback / merge tag toolbar
		mergeTags: 'علامات الدمج',
		newMergeTag: 'علامة دمج جديدة',
		fromSource: 'من %{source}',
		csv: 'csv',
		// Card format + invitation event tool
		format: {
			tool: 'التنسيق والحدث',
			title: 'تنسيق البطاقة',
			single: 'صفحة واحدة',
			singleDesc: 'صفحة واحدة فقط.',
			double: 'أمامي وخلفي',
			doubleDesc: 'صفحتان: وجه أمامي وآخر خلفي.',
			folded: 'بطاقة مطوية (4 صفحات)',
			foldedDesc: 'بطاقة كلاسيكية متعددة الصفحات.',
			front: 'الأمام',
			back: 'الخلف',
			card: 'البطاقة',
			pageLimit: 'يسمح تنسيق البطاقة هذا بحد أقصى %{max} صفحة.',
			tooManyPages: 'تحتوي هذه البطاقة على صفحات أكثر مما يسمح به تنسيق %{max} صفحة. احذف بعض الصفحات أولاً.',
		},
		event: {
			toggle: 'هذه البطاقة دعوة',
			eventTitle: 'عنوان الحدث',
			start: 'البداية',
			end: 'النهاية (اختياري)',
			timezone: 'المنطقة الزمنية',
			inPerson: 'حضوري',
			online: 'عبر الإنترنت',
			address: 'العنوان',
			hostNote: 'ملاحظة من المضيف',
			allowGuests: 'السماح بالضيوف (+1)',
			save: 'حفظ الدعوة',
			saved: 'تم حفظ الدعوة',
			errorTitle: 'خطأ',
			saveFailed: 'تعذر حفظ التغييرات',
			errors: {
				titleRequired: 'أدخل عنوانًا للحدث.',
				titleTooLong: 'يجب ألا يتجاوز العنوان 200 حرف.',
				startRequired: 'اختر تاريخ ووقت البداية.',
				endInvalid: 'أدخل تاريخ ووقت نهاية صالحين.',
				endBeforeStart: 'يجب ألا تسبق النهاية البداية.',
				timezoneInvalid: 'اختر منطقة زمنية صالحة.',
				urlInvalid: 'أدخل رابط http(s) صالحًا.',
				hostNoteTooLong: 'يجب ألا تتجاوز الملاحظة 1000 حرف.',
			},
		},
	} as Record<string, any>,
};
export default editor;
